import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Copy text to clipboard with a safe fallback for sandboxed / iframed
 * contexts where `navigator.clipboard.writeText` is blocked by the
 * Permissions Policy (e.g. preview iframes, Stackblitz, etc.).
 * Returns true on success, false on failure.
 */
export async function safeCopy(text) {
  const value = String(text ?? "");
  // Try the modern async API first (only works on secure, top-level docs)
  try {
    if (typeof navigator !== "undefined" && navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(value);
      return true;
    }
  } catch {
    // fall through to legacy
  }
  // Legacy fallback — works in sandboxed iframes
  try {
    const ta = document.createElement("textarea");
    ta.value = value;
    ta.setAttribute("readonly", "");
    ta.style.position = "fixed";
    ta.style.top = "-1000px";
    ta.style.left = "-1000px";
    ta.style.opacity = "0";
    document.body.appendChild(ta);
    ta.focus();
    ta.select();
    ta.setSelectionRange(0, value.length);
    const ok = document.execCommand && document.execCommand("copy");
    document.body.removeChild(ta);
    return !!ok;
  } catch {
    return false;
  }
}
